export const isMocked =
  (typeof import.meta !== 'undefined' &&
    typeof import.meta.env !== 'undefined' &&
    import.meta.env.MODE !== 'production' &&
    import.meta.env.VITE_USE_WAGMI_MOCKS === 'true') ||
  (typeof process !== 'undefined' &&
    process.env.NODE_ENV !== 'production' &&
    process.env.VITE_USE_WAGMI_MOCKS === 'true');
